import { useEffect, useState } from "react";
import baseURL from "../../../config/api";
import DeleteCreditCard from "./DeleteCreditCard";
import { RxCross1 } from "react-icons/rx";
import { BsSearch } from "react-icons/bs";
import { RiArrowDownSFill } from "react-icons/ri";
import Pagination from "../../../components/Pagination";
import Cookies from "js-cookie";

export const AllCreditCards = () => {
    const token = Cookies.get("token-my-cdir");
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isSaved, setIsSaved] = useState<boolean>(false);
    const [particularCreditDetails, setParticularCreditDetails] = useState<any>();
    const [editPopup, setEditPopup] = useState<boolean>(false);

    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [displayFilter, setDisplayFilter] = useState<boolean>(false);
    const [creditCardFilterValue, setCreditCardFilterValue] = useState(0);
    const [paginationModel, setPaginationModel] = useState<{ page: number, size: number }>({
        page: 0,
        size: 10,
    });
    const [totalLength, setTotalLength] = useState<number>(0);
    const [selectedFilter, setSelectedFilter] = useState<string>("CardHolder Name");
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [showEntries, setShowEntries] = useState<number>(10);


    useEffect(() => {
        if (isSaved && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                size: 10,
            };
            setPaginationModel(newPaginationModel);
            setIsSaved(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSaved])


    useEffect(() => {
        if (searchValue === "" && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                size: paginationModel.size,
            };

            setPaginationModel(newPaginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue === "") {
            setIsFirstTime(false)
            apiCall(paginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const apiCall = (newPaginationModel: { page: number, size: number }) => {
        setIsDataLoaded(true);
        fetch(`${baseURL}creditCard/GetCreditCardReportPaging/${newPaginationModel.page},${newPaginationModel.size}`, {
            headers: {
                Authorization: `Bearer ${token?.toString()}`
            }
        })
            .then((res) => res.json())
            .then((data) => {
                const result = data.creditCardReport.map((item: any) => {
                    return {
                        ...item,
                        paymentGateway: item.paymentGateway ? item.paymentGateway : "",
                    };
                })

                setSearchTableData(result);
                setTotalLength(data.count);
                setIsDataLoaded(false);

            }).catch((error) => {
                console.log(error);
                setIsDataLoaded(false);
                setSearchTableData([]);
                setTotalLength(0);
            });
    }


    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                const newPaginationModel = {
                    page: 0,
                    size: paginationModel.size,
                };

                setPaginationModel(newPaginationModel);

            }, 1000);
        }

        return () => clearTimeout(timeOutId);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue !== "") {
            filteApiCall(paginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const filteApiCall = (newPaginationModel: { page: number, size: number }) => {
        let filterData: any[] = [];
        setIsDataLoaded(true);
        switch (creditCardFilterValue) {
            case 0:
                fetch(
                    `${baseURL}creditCard/GetCreditCardReportSearchWithCardholderName/${searchValue},${newPaginationModel.page},${newPaginationModel.size}`, {
                    headers: {
                        Authorization: `Bearer ${token?.toString()}`
                    }
                }
                )
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.creditCardReport.map((item: any) => {
                            return {
                                ...item,
                                paymentGateway: item.paymentGateway ? item.paymentGateway : "",
                            };
                        })

                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setIsDataLoaded(false);

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsDataLoaded(false);
                        setSearchTableData([]);
                        setTotalLength(0);
                    });

                break;
            case 1:
                fetch(
                    `${baseURL}creditCard/GetCreditCardReportSearchWithLast4Digits/${searchValue},${newPaginationModel.page},${newPaginationModel.size}`, {
                    headers: {
                        Authorization: `Bearer ${token?.toString()}`
                    }
                }
                )
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.creditCardReport.map((item: any) => {
                            return {
                                ...item,
                                paymentGateway: item.paymentGateway ? item.paymentGateway : "",
                            };
                        })
                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setIsDataLoaded(false);

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsDataLoaded(false);
                        setSearchTableData([]);
                        setTotalLength(0);
                    });

                break;
        }
    }

    const applyFilter = () => {
        setSelectedFilter(() =>
            creditCardFilterValue === 0 ? "CardHolder Name" : "Last 4 Digits"
        );
        setSearchValue("");
        setDisplayFilter(false);
    };

    const clearFilter = () => {
        setSearchValue("");
        setDisplayFilter(false);
    };


    return (
        <>
            <div className="w-full px-3 xm:px-4">

                {/* FILTER + SEARCH */}
                <div className="flex flex-col xm:flex-row gap-3 justify-between xm:items-center border border-black p-2 mt-4">
                    <div className="relative flex flex-col xm:flex-row gap-3 items-start xm:items-center w-full">

                        {/* FILTER */}
                        <div className="relative w-full xm:w-auto">
                            <button
                                className="bg-secondary text-white px-3 py-2 xm:py-1 rounded-md flex items-center justify-between w-full xm:w-auto whitespace-nowrap"
                                onClick={() => setDisplayFilter(!displayFilter)}
                            >
                                {selectedFilter}
                                <RiArrowDownSFill className="ml-1" />
                            </button>

                            <div
                                className={`${displayFilter ? "block" : "hidden"
                                    } absolute z-10 w-full xm:w-40 p-2 bg-white border border-black mt-2 xm:mt-0 xm:top-0 xm:left-full`}
                            >
                                <div className="flex justify-between">
                                    <label className="text-xs font-bold">Fields</label>
                                    <div
                                        onClick={() => setDisplayFilter(false)}
                                        className="w-4 h-4 cursor-pointer text-sm text-center"
                                    >
                                        <RxCross1 />
                                    </div>
                                </div>

                                <select
                                    className="w-full text-xs py-1 border mt-1"
                                    value={creditCardFilterValue}
                                    onChange={(e) =>
                                        setCreditCardFilterValue(parseInt(e.target.value))
                                    }
                                >
                                    <option value="0">CardHolder Name</option>
                                    <option value="1">Last 4 Digits</option>
                                </select>

                                <div className="flex mt-2 justify-between">
                                    <button
                                        className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full mr-1 whitespace-nowrap"
                                        onClick={() => applyFilter()}
                                    >
                                        Apply Filter
                                    </button>

                                    <button
                                        className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full ml-1 hover:bg-secondary"
                                        onClick={() => clearFilter()}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* SEARCH */}
                        <div className="flex items-center gap-2 w-full border px-2 py-1 rounded">
                            <div className="h-4 w-4 text-gray-900">
                                <BsSearch />
                            </div>

                            <input
                                type="text"
                                placeholder="Search…"
                                className="w-full text-sm xm:text-lg pl-2 outline-none"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                            />
                        </div>

                    </div>
                </div>

                {/* TABLE */}
                <div className="mt-6 w-full overflow-x-auto">
                    {!isDataLoaded ? (
                        <div className="border-none text-xs break-words">

                            <table className="min-w-[700px] w-full bg-white text-center">
                                <thead className="bg-gray-200 whitespace-nowrap">
                                    <tr>
                                        <th className="px-4 xm:px-6 py-2 text-xs xm:text-sm font-semibold text-black">#</th>
                                        <th className="px-4 xm:px-6 py-2 text-xs xm:text-sm font-semibold text-black">Payment Gateway</th>
                                        <th className="px-4 xm:px-6 py-2 text-xs xm:text-sm font-semibold text-black">Cardholder's Name</th>
                                        <th className="px-4 xm:px-6 py-2 text-xs xm:text-sm font-semibold text-black">Brand</th>
                                        <th className="px-4 xm:px-6 py-2 text-xs xm:text-sm font-semibold text-black">Expiration Date</th>
                                        <th className="px-4 xm:px-6 py-2 text-xs xm:text-sm font-semibold text-black">Last 4 Digits</th>
                                    </tr>
                                </thead>

                                <tbody className="whitespace-nowrap">
                                    {searchTableData.length > 0 ? (
                                        searchTableData.slice(0, showEntries).map((row, index) => (
                                            <tr
                                                key={row.id}
                                                className={index % 2 === 0 ? "bg-blue-50" : "bg-blue-100"}
                                            >
                                                <td className="px-4 xm:px-6 py-4 text-xs xm:text-sm">
                                                    <p
                                                        className="text-secondary underline cursor-pointer"
                                                        onClick={() => {
                                                            setEditPopup(true);
                                                            setParticularCreditDetails(row);
                                                        }}
                                                    >
                                                        {row.id}
                                                    </p>
                                                </td>

                                                <td className="px-4 xm:px-6 py-4 text-xs xm:text-sm">
                                                    {row.paymentGateway}
                                                </td>

                                                <td className="px-4 xm:px-6 py-4 text-xs xm:text-sm break-words">
                                                    {row.cardholderName}
                                                </td>

                                                <td className="px-4 xm:px-6 py-4 text-xs xm:text-sm">
                                                    {row.brand}
                                                </td>

                                                <td className="px-4 xm:px-6 py-4 text-xs xm:text-sm">
                                                    {row.expirationDate}
                                                </td>

                                                <td className="px-4 xm:px-6 py-4 text-xs xm:text-sm">
                                                    {row.creditCardNumber}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={7} className="px-2 py-1 text-sm font-medium">
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="min-w-full h-[300px] xm:h-[480px] flex justify-center items-center">
                            <div className="flex flex-col items-center">
                                <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-current border-r-transparent text-secondary"></div>
                                <span className="text-sm mt-2">Loading...</span>
                            </div>
                        </div>
                    )}


                </div>
                {totalLength > 0 && (
                    <div className="mt-6 flex justify-center">
                        <Pagination
                            pageOption={[5, 10, 15, 20, 25, 50, 75, 100]}
                            totalLength={totalLength}
                            paginationModel={paginationModel}
                            setPaginationModel={setPaginationModel}
                            showEntries={showEntries}
                            setShowEntries={setShowEntries}
                        />
                    </div>
                )}
            </div>


            <div>
                <DeleteCreditCard
                    editPopup={editPopup}
                    hidePopup={() => setEditPopup(false)}
                    deleteCreditCard={() => {
                        setEditPopup(false);
                        setIsSaved(true);
                    }}
                    particularCreditDetails={particularCreditDetails}
                />
            </div>
        </>
    );
};
